/**
 * The padlock, drawn rather than imported.
 *
 * `design/screens/` draws this shape in two places at two sizes and two
 * colours — the funnels-list band legend and its upsell callout
 * (DECISION-061), and the Design tab's Free branding row (DECISION-057) —
 * always as two boxes, never as an icon font or an SVG asset. Lucide is the
 * icon set (`docs/ARCH.md`), and this is not one of its icons: it is a
 * 12×14px mark tuned to sit on a 13px line, which `Lock` at 14px does not.
 *
 * IT INHERITS COLOUR. The mockups draw it in `--mdx-slate` on the legend and
 * `--mdx-brand-deep` in the callout, which is one mark in two contexts rather
 * than two marks — so it reads `currentColor` and the caller sets the text
 * colour, exactly as the mockups' own two instances differ.
 *
 * THE 1.5px HAIRLINE IS AN INLINE `var()`, NOT A CLASS. `--mdx-space-1-5` is
 * the token (`design/tokens.css`, "drawn-icon hairline — bar, gap, border"),
 * and Tailwind v4 feeds `--spacing-*` to width, height, padding, margin and
 * gap — but not to border-width, which has no theme namespace here. The only
 * class form left would be `border-[1.5px]`, which `eslint.config.js` bans by
 * name. A `var()` reference is not a hardcoded value; it is the token.
 *
 * Stories 6.1 and 6.5.
 */

/** The shackle's hairline — one token, referenced twice. */
const SHACKLE_BORDER = { borderWidth: 'var(--mdx-space-1-5) var(--mdx-space-1-5) 0' }

export function LockMark({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const small = size === 'sm'
  return (
    <span
      aria-hidden="true"
      className="inline-flex flex-none flex-col items-center"
    >
      <span
        className={[
          'box-border border-solid border-current',
          small ? 'h-mdx-4 w-mdx-6 rounded-t-mdx-3' : 'h-mdx-5 w-mdx-8 rounded-t-mdx-4',
        ].join(' ')}
        style={SHACKLE_BORDER}
      />
      <span
        className={[
          'rounded-mdx-2 bg-current',
          small ? 'h-mdx-7 w-mdx-9' : 'h-mdx-9 w-mdx-12',
        ].join(' ')}
      />
    </span>
  )
}
